// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"977d045abdf4192034f9","691":"9e6eaf6fafbe29653331"}[chunkId] + ".js";
};